import { render, staticRenderFns } from "./CreatePdfArchiveModalCreated.vue?vue&type=template&id=2172d402&scoped=true"
import script from "./CreatePdfArchiveModalCreated.vue?vue&type=script&lang=ts"
export * from "./CreatePdfArchiveModalCreated.vue?vue&type=script&lang=ts"
import style0 from "./CreatePdfArchiveModalCreated.vue?vue&type=style&index=0&id=2172d402&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2172d402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2172d402')) {
      api.createRecord('2172d402', component.options)
    } else {
      api.reload('2172d402', component.options)
    }
    module.hot.accept("./CreatePdfArchiveModalCreated.vue?vue&type=template&id=2172d402&scoped=true", function () {
      api.rerender('2172d402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pdf-archive/CreatePdfArchiveModalCreated.vue"
export default component.exports